import React, { type ReactNode } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import {
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_SUBTLE_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_SELECTED_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_BACKGROUND_SELECTED_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_SELECTED_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_TEXT_ACCENT_SELECTED_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BACKGROUND_INPUT_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BACKGROUND_BRAND_BOLD_VAR,
	UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_INVERSE_VAR,
} from '@atlassian/navigation-kit-common';
import { useSoftwareProjectTheming } from '@atlassian/jira-project-theme-providers/src/controllers/software-theme/index.tsx';

export const ContrastThemeWrapper = ({ children }: { children: ReactNode }) => {
	const { isSoftwareProject } = useSoftwareProjectTheming();

	if (isSoftwareProject) {
		return <Box xcss={overrideStyles}>{children}</Box>;
	}
	return children;
};

const overrideStyles = xcss({
	// @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	'--project-color-text': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_VAR}, ${token('color.text')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	'--project-color-text-subtle': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_SUBTLE_VAR}, ${token('color.text.subtle')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-color-border': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_VAR}, ${token('color.border')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-background-selected': `var(${UNSAFE_HORIZONTAL_NAVIGATION_BACKGROUND_SELECTED_VAR}, ${token('color.background.selected')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-color-border-selected': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BORDER_SELECTED_VAR}, ${token('color.border.selected')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-color-text-selected': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_SELECTED_VAR}, ${token('color.text.selected')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-text-accent-selected': `var(${UNSAFE_HORIZONTAL_NAVIGATION_TEXT_ACCENT_SELECTED_VAR}, ${token('color.text.selected')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-color-background-input': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BACKGROUND_INPUT_VAR}, ${token('color.background.input')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-color-background-brand-bold': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_BACKGROUND_BRAND_BOLD_VAR}, ${token('color.background.brand.bold')})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	'--project-color-text-inverse': `var(${UNSAFE_HORIZONTAL_NAVIGATION_COLOR_TEXT_INVERSE_VAR}, ${token('color.text.inverse')})`,
});
